{
  "page404": {
    "title": "Oeps! Pagina niet gevonden",
    "message": "Sorry, maar de pagina die u zoekt bestaat niet, is verwijderd, van naam veranderd of is tijdelijk niet beschikbaar",
    "homePage": "Terug naar startpagina"
  }
}
